<div class="container">
    <form [formGroup]="runtimeForm">
        <div *ngIf="showProgressBar">
            <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
          </div>
        <h1 style="font-size: 20px;" class="text-center">Add/Edit Billing Items</h1>
        <div>
        </div>
        <div formArrayName="items">
            <mat-dialog-content class="row billingcode">
                <ng-container *ngFor="let items of items().controls; let empIndex=index">
                    <div class="row fields-container d-flex flex-wrap" [formGroupName]="empIndex">
                        <mat-form-field class="sr-width mat-form-field-infix-class" *ngIf="this.addformShow!='Add'">
                            <input disabled matInput placeholder="Sr No." [value]=empIndex+1>
                        </mat-form-field>
                        <mat-form-field class="margin-left mat-width mat-form-field-infix-class"
                            *ngIf="this.addformShow=='Add'">
                            <input matInput placeholder="Sr No.">
                        </mat-form-field>

                        <mat-form-field class="mat-form-field-infix-class margin-left mat-max-width" [ngStyle]="{'width': calCss}">
                            <mat-select placeholder="Work Item"  (selectionChange)="changePowerSupplyModel($event, empIndex)" formControlName="billingCode">
                                <mat-option>--</mat-option>
                                <mat-option *ngFor="let code of rowData" [value]="code" [disabled]="isSelected(code)">
                                    {{code}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="items.get('billingCode').errors?.required">
                                Work item is required
                                   </mat-error>
                        </mat-form-field>
                        <!-- <mat-form-field class="margin-left mat-max-width-part mat-form-field-infix-class" [ngStyle]="{'width': calCss}">
                            <input matInput formControlName="workItemDesc" placeholder="Work Description">
                            <mat-error *ngIf="items.get('workItemDesc').errors?.required">
                                Work Description is required
                              </mat-error>
                        </mat-form-field> -->
                        <!-- <mat-form-field class="margin-left mat-max-width-part mat-form-field-infix-class">
                            <input matInput formControlName="partNumbers" placeholder="Part Number">
                            <mat-error *ngIf="items.get('partNumbers').errors?.required">
                           Part Number is required
                              </mat-error>
                        </mat-form-field> -->
                        <mat-form-field class="margin-left width mat-form-field-infix-class">
                            <input matInput type="number" min="0" formControlName="quantity" placeholder="Quantity">
                            <!-- <mat-error *ngIf="items.get('quantity').errors?.required">
                                Quantity is required
                              </mat-error> -->
                        </mat-form-field>

                            <span class="delete-icon-container">
                                <a matTooltip="Delete" (click)="removeCertificationsWorkitem(empIndex,items)">
                                    <i class="fa fa-trash trash-icon" aria-hidden="true"></i>
                                </a>
                            </span>
                            <span *ngIf="empIndex == 0" class="delete-icon-container">
                                <a matTooltip="Add" (click)="addCertificationsWorkitem()">
                                    <i class="fa fa-plus-square square-icon" aria-hidden="true"></i>
                                </a>
                            </span>
                    </div>
                </ng-container>
            </mat-dialog-content>
        </div>
    </form>
    <form [formGroup]="runtimeFormmat">
        <h1 style="font-size: 20px;" class="text-center">Add/Edit Materials</h1>
        <div formArrayName="items">
            <mat-dialog-content class="row materialcode">
                <ng-container *ngFor="let items of itemsmat().controls; let matIndex=index">
                    <div class="row fields-container d-flex flex-wrap" [formGroupName]="matIndex">
                        <mat-form-field class="sr-width mat-form-field-infix-class" *ngIf="this.addformShow!='Add'">
                            <input disabled matInput placeholder="Sr No." [value]=matIndex+1>
                        </mat-form-field>
                        <mat-form-field class="margin-left mat-width mat-form-field-infix-class"
                            *ngIf="this.addformShow=='Add'">
                            <input matInput placeholder="Sr No.">
                        </mat-form-field>
                        <mat-form-field class="mat-form-field-infix-class margin-left mat-max-width"
                            style="min-width: 250px !important;">
                            <mat-select placeholder="Material Type" (selectionChange)="changematType($event.value, matIndex)"
                                formControlName="materialType">
                                <mat-option>--</mat-option>
                                <mat-option *ngFor="let datamatType of uniqueDatamatType" [value]="datamatType">
                                    {{datamatType}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="items.get('materialType').errors?.required">
                                Material Type is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="row fields-container d-flex flex-wrap" [formGroupName]="matIndex">
                        <mat-form-field class="mat-form-field-infix-class margin-left mat-max-width"
                            style="min-width: 250px !important;">
                            <mat-select placeholder="Model/Description"
                                formControlName="modelDesc">
                                <mat-option>--</mat-option>
                                <mat-option [disabled]="isSelectedmaterial(matcode)" *ngFor="let matcode of rowDatamatTypechanged[matIndex]" [value]="matcode">
                                    {{matcode}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="items.get('modelDesc').errors?.required">
                                Model/Description is required
                            </mat-error>
                        </mat-form-field><br>

                        <mat-form-field class="margin-left width mat-form-field-infix-class" style="min-width: 80px !important;">
                            <input matInput type="number" min="0" formControlName="quantitymat" placeholder="Quantity">
                        </mat-form-field>
                        <span class="delete-icon-container">
                            <a matTooltip="Delete" (click)="removeCertificationsmmaterial(matIndex,items)">
                                <i class="fa fa-trash trash-icon" aria-hidden="true"></i>
                            </a>
                        </span>
                        <span *ngIf="matIndex == 0" class="delete-icon-container">
                            <a matTooltip="Add" (click)="addCertificationsWorkitemmaterial()">
                                <i class="fa fa-plus-square square-icon" aria-hidden="true"></i>
                            </a>
                        </span>
                    </div>
                </ng-container>
            </mat-dialog-content>
        </div>

        <div class="d-flex justify-content-center">
            <mat-dialog-actions>
                <button (click)="addWorkitem()" *ngIf="this.workArrayData.length == 0 && this.workArrayDataMaterial.length == 0"
                    [disabled]="runtimeForm.invalid || runtimeFormmat.invalid || showProgressBar" mat-raised-button color="primary">Save</button>
                <button *ngIf="this.workArrayData.length > 0 || this.workArrayDataMaterial.length > 0" (click)="EditWorkiteData()"
                    [disabled]="runtimeForm.invalid || runtimeFormmat.invalid || showProgressBar" mat-raised-button color="primary">Save</button>

                <button mat-button mat-raised-button type="button" (click)="dialogRef.close()">Close</button>
            </mat-dialog-actions>
        </div>

        <br>
        <mat-error *ngIf="notSuccess" class="d-flex justify-content-center">
            <strong>Unable to Add. Please try later !! </strong>
        </mat-error>
        <mat-error *ngIf="getError" class="d-flex justify-content-center">
            <strong>Unable to fetch Data. Please try later !! </strong>
        </mat-error>
    </form>
</div>
